<script lang="ts">
  import { onMount } from 'svelte';
  import { auditFor } from '../lib/audit';
  import { go } from '../lib/stores';
  import type { AuditEntry } from '../lib/db';

  export let treeId: string;
  let rows: AuditEntry[] = [];

  onMount(async () => { rows = await auditFor(treeId, 500); });

  function iso(ts: number) { return new Date(ts).toISOString().slice(0, 19).replace('T', ' '); }
</script>

<div class="wrap">
  <div class="head">
    <div class="row meta">
      <button class="ghost small" on:click={() => go(`/tree/${treeId}`)}>← tree</button>
      <span class="chip">audit</span>
      <span class="chip">tree.{treeId.slice(0, 8)}</span>
      <span class="chip">{rows.length} entries</span>
    </div>
    <h2>Audit log</h2>
    <p class="dim small">Every write, every actor. Reverse-chronological.</p>
  </div>

  <div class="card">
    {#if !rows.length}
      <p class="dim small">no activity yet.</p>
    {:else}
      <table>
        <thead>
          <tr><th>when</th><th>actor</th><th>action</th><th>target</th></tr>
        </thead>
        <tbody>
          {#each rows as r}
            <tr>
              <td class="mono small dim">{iso(r.at)}</td>
              <td class="mono small">{r.actor}</td>
              <td><span class="chip">{r.action}</span></td>
              <td class="mono small dim">{r.targetId?.slice(0, 8) ?? ''}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    {/if}
  </div>
</div>

<style>
  .wrap { max-width: 980px; margin: 36px auto; padding: 0 24px; display: grid; gap: 20px; }
  .head .meta { margin-bottom: 12px; }
  h2 { font-size: var(--ls-step-4); margin: 0 0 6px; }
  .small { font-size: var(--ls-step-0); }
  table { width: 100%; border-collapse: collapse; }
  th, td { text-align: left; padding: 8px 12px; border-bottom: 1px solid var(--ls-border); }
  th { font-family: var(--ls-font-mono); font-size: 11px; color: var(--ls-text-dim); font-weight: 500; }
  tr:last-child td { border-bottom: none; }
  tr:hover td { background: var(--ls-surface-2); }
</style>
